<div class="app-main">
  <router-outlet></router-outlet>
</div>